import { AuthConfig } from 'angular-oauth2-oidc';

export const baseOAuthConfig: AuthConfig = {
    clientId: 'leadmanagement_waremaplus',
    responseType: 'code',
    useSilentRefresh: true,
    silentRefreshTimeout: 1000 * 5,
    scope:
        // eslint-disable-next-line max-len
        'openid profile offline_access leadcloud_appointments leadcloud_shop leadcloud_offers leadcloud_agreements devicecloud_devicecloudservice_devices_get devicecloud_devicecloudservice_commoncommand_ping devicecloud_devicecloudservice_devices_unregister warema/identity/api/change/password warema/identity/api/public warema/identity/api/delete/account leadcloud_waremaconfigurator',
};
